<template>
    <div> 
        <b-navbar class="navbar" toggleable="lg" type="dark" variant="danger">
            <b-navbar-brand to="/">RouteSys</b-navbar-brand>

            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
                <b-navbar-nav>
                    <b-nav-item to="/">Home</b-nav-item>
                    <b-nav-item to="/jobs" v-if="nivel!=='fornecedor'">Jobs</b-nav-item>
                    <b-nav-item to="/colaboradores" v-if="nivel==='admin'">Colaboradores</b-nav-item>
                    <b-nav-item to="/extrato">Financeiro</b-nav-item>
                    <b-nav-item to="/pagarJobs" v-if="nivel!=='prestador'">Pagamento de Jobs</b-nav-item>
                    <b-nav-item to="/finalizaJobs" v-if="nivel!=='fornecedor'">Finalização de Jobs</b-nav-item>
                    <b-nav-item-dropdown text="Administrativo" v-if="nivel==='admin'">
                        <b-dropdown-item to="/categorias">Categorias</b-dropdown-item>
                        <b-dropdown-item to="/subcategorias">Subcategorias</b-dropdown-item>
                        <b-dropdown-item to="/tipoServico">Serviços</b-dropdown-item>
                        <b-dropdown-item to="/confirmaJobs">Confirmar Pagamento de Jobs</b-dropdown-item>
                        <b-dropdown-item to="/validaJobs">Validar Jobs</b-dropdown-item>
                        <b-dropdown-item to="/extratoEmpresa">Extrato das Empresas</b-dropdown-item>
                    </b-nav-item-dropdown>
                </b-navbar-nav>

                <!-- Right aligned nav items -->
                <b-navbar-nav class="ml-auto">
                    <b-nav-item-dropdown :text="usuario" right>
                        <b-dropdown-item to="/meusJobs" v-if="nivel!=='prestador'">Meus Jobs Criados</b-dropdown-item>
                        <b-dropdown-item to="/colaboradorSubcategoria">Minhas Subcategorias</b-dropdown-item>
                        <b-dropdown-item to="/configs" v-if="nivel==='admin'">Configuração</b-dropdown-item>
                        <b-dropdown-item href @click.prevent="logout">Logout</b-dropdown-item>
                    </b-nav-item-dropdown>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>
    </div>
</template>

<script>
import { baseApiUrl } from '@/global'
import axios from 'axios'
import { VueEasyJwt } from 'vue-easy-jwt'

export default {
    name: "Menu",
    data: function() {
        return {
            jwt: new VueEasyJwt(),
            usuario: '',
            nivel: ''
        }
    },
    computed: {},
    methods: {
        logout () {
            const local = localStorage.getItem('__SYSTEM_USER')
            const jwt = JSON.parse(local)
            axios(`${baseApiUrl}/backend/SELECT/logout.php?jwt=${jwt}`)
            .then(() => {
                this.$toasted.global.defaultSuccess({ message : 'Logout Realizado com sucesso!' })
                localStorage.removeItem('__SYSTEM_USER')
                this.$store.commit('toggleVisible', false)
                this.$router.push({ path: '/login' })
            })
            .catch(
                (e) => {
                this.$toasted.global.defaultError({ message : e.response.data['dados'] })
            })

        }
    },
    mounted() {
        const local = localStorage.getItem('__SYSTEM_USER')
        const decodedToken = this.jwt.decodeToken(local)
        if (local === null) {
            this.$router.push({ path: '/login' })
            this.$store.commit('toggleVisible', false)
        } else {
            this.nivel = decodedToken['data'].nivel
            this.usuario = decodedToken['data'].nome
            this.$store.commit('toggleVisible', true)
        }
    }
}
</script>

<style>
.navbar {
    z-index: 9;
}
</style>